import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _archivePlanRequest = {};
var _archivePlanResponse = { plan: '_plan' };
var _arrangePlansRequest = {};
var _arrangePlansResponse = {};
var _bulkArchivePlanRequest = {};
var _bulkArchivePlanResponse = { results: '_bulkPlanResult' };
var _bulkPlanResult = { plan: '_plan' };
var _clearPrimaryRequest = {};
var _clearPrimaryResponse = {};
var _countPlansRequest = {};
var _countPlansResponse = {};
var _createPlanRequest = { plan: '_plan' };
var _createPlanResponse = { plan: '_plan' };
var _getPlanRequest = {};
var _getPlanResponse = { plan: '_plan' };
var _getPlansPremiumStatusRequest = {};
var _getPlansPremiumStatusResponse = {};
var _getPlanStatsRequest = {};
var _getPlanStatsResponse = {};
var _listPlansRequest = {};
var _listPlansResponse = { plans: '_plan' };
var _listPublicPlansRequest = {};
var _listPublicPlansResponse = { plans: '_publicPlan' };
var _makePlanPrimaryRequest = {};
var _makePlanPrimaryResponse = { plan: '_plan' };
var _plan = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _publicPlan = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _queryPublicPlansRequest = {};
var _queryPublicPlansResponse = { plans: '_publicPlan' };
var _searchPlansRequest = {};
var _searchPlansResponse = { plans: '_plan' };
var _setPlanVisibilityRequest = {};
var _setPlanVisibilityResponse = { plan: '_plan' };
var _updatePlanRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    plan: '_plan',
};
var _updatePlanResponse = { plan: '_plan' };
function resolveComWixpressMembershipV2PlansPlansServiceV2Url(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/plan-proxy',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/paid-plans/v2/plans',
                destPath: '/v2/plans',
            },
        ],
        '*.pub.wix-code.com': [
            {
                srcPath: '/_api/paid-plans/v2/plans',
                destPath: '/v2/plans',
            },
        ],
        '*.wixapps.net': [
            {
                srcPath: '/_api/paid-plans/v2/plans',
                destPath: '/v2/plans',
            },
        ],
        _: [
            {
                srcPath: '/_api/paid-plans/v2/plans',
                destPath: '/v2/plans',
            },
        ],
        'editor-flow.wixapps.net': [
            {
                srcPath: '/_api/paid-plans/v2/plans',
                destPath: '/v2/plans',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/paid-plans/v2/plans',
                destPath: '/v2/plans',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/paid-plans/v2/plans',
                destPath: '/v2/plans',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/paid-plans/v2/plans',
                destPath: '/v2/plans',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/paid-plans/v2/plans',
                destPath: '/v2/plans',
            },
        ],
        'forums._base_domain_': [
            {
                srcPath: '/_api/paid-plans/v2/plans',
                destPath: '/v2/plans',
            },
        ],
        'forums.wixapps.net': [
            {
                srcPath: '/_api/paid-plans/v2/plans',
                destPath: '/v2/plans',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/paid-plans/v2/plans',
                destPath: '/v2/plans',
            },
            {
                srcPath: '/_api/pricing-plans/v2/plans',
                destPath: '/v2/plans',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/paid-plans/v2/plans',
                destPath: '/v2/plans',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/pricing-plans/v2/plans',
                destPath: '/v2/plans',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Retrieves a list of up to 100 public pricing plans. Public plans are visible plans that are available to site visitors and can be purchased. */
export function listPublicPlans(payload) {
    var _a = serializer(_listPublicPlansRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listPublicPlansResponse, {
        _publicPlan: _publicPlan,
    }).fromJSON;
    function __listPublicPlans(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v2.plan',
            method: 'GET',
            methodFqn: 'com.wixpress.membership.v2.plans.PlansServiceV2.ListPublicPlans',
            url: resolveComWixpressMembershipV2PlansPlansServiceV2Url({
                protoPath: '/v2/plans/public',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listPublicPlans.fromReq = fromReq;
    __listPublicPlans.__isAmbassador = true;
    return __listPublicPlans;
}
/** Retrieves a list of up to 1,000 public pricing plans, given the provided pagination, sorting, and filtering ([SDK](https://dev.wix.com/docs/sdk/backend-modules/pricing-plans/plans/query-public-plans) | [REST](https://dev.wix.com/api/rest/wix-pricing-plans/pricing-plans/plans/filter-and-sort)). */
export function queryPublicPlans(payload) {
    var _a = serializer(_queryPublicPlansRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryPublicPlansResponse, {
        _publicPlan: _publicPlan,
    }).fromJSON;
    function __queryPublicPlans(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v2.plan',
            method: 'POST',
            methodFqn: 'com.wixpress.membership.v2.plans.PlansServiceV2.QueryPublicPlans',
            url: resolveComWixpressMembershipV2PlansPlansServiceV2Url({
                protoPath: '/v2/plans/public/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryPublicPlans.fromReq = fromReq;
    __queryPublicPlans.__isAmbassador = true;
    return __queryPublicPlans;
}
/** Retrieves a pricing plan by ID. */
export function getPlan(payload) {
    var _a = serializer(_getPlanRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getPlanResponse, { _plan: _plan }).fromJSON;
    function __getPlan(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v2.plan',
            method: 'GET',
            methodFqn: 'com.wixpress.membership.v2.plans.PlansServiceV2.GetPlan',
            url: resolveComWixpressMembershipV2PlansPlansServiceV2Url({
                protoPath: '/v2/plans/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getPlan.fromReq = fromReq;
    __getPlan.__isAmbassador = true;
    return __getPlan;
}
/** Retrieves a list of up to 100 pricing plans (including public, hidden, and archived plans). */
export function listPlans(payload) {
    var _a = serializer(_listPlansRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listPlansResponse, { _plan: _plan }).fromJSON;
    function __listPlans(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v2.plan',
            method: 'GET',
            methodFqn: 'com.wixpress.membership.v2.plans.PlansServiceV2.ListPlans',
            url: resolveComWixpressMembershipV2PlansPlansServiceV2Url({
                protoPath: '/v2/plans',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listPlans.fromReq = fromReq;
    __listPlans.__isAmbassador = true;
    return __listPlans;
}
/** Gets statistics about the pricing plans. Currently provides only the total number of pricing plans, including archived plans. */
export function getPlanStats(payload) {
    var _a = serializer(_getPlanStatsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getPlanStatsResponse, {}).fromJSON;
    function __getPlanStats(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v2.plan',
            method: 'GET',
            methodFqn: 'com.wixpress.membership.v2.plans.PlansServiceV2.GetPlanStats',
            url: resolveComWixpressMembershipV2PlansPlansServiceV2Url({
                protoPath: '/v2/plans/stats',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getPlanStats.fromReq = fromReq;
    __getPlanStats.__isAmbassador = true;
    return __getPlanStats;
}
/**
 * Creates a pricing plan. The specified `plan` object must contain a pricing model. A pricing model can be 1 of the following:
 * - **A subscription**: A subscription with recurring payments and how often the plan occurs. Subscriptions can have free trial days.
 * - **A plan that doesn't renew**: A single payment for a specific duration that doesn't renew.
 * - **An unlimited plan**: A single payment for an unlimited amount of time (until canceled).
 * Pricing plans are available to the Wix user in the Pricing Plans section in a site's dashboard.
 */
export function createPlan(payload) {
    var _a = serializer(_createPlanRequest, {
        _plan: _plan,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createPlanResponse, { _plan: _plan }).fromJSON;
    function __createPlan(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v2.plan',
            method: 'POST',
            methodFqn: 'com.wixpress.membership.v2.plans.PlansServiceV2.CreatePlan',
            url: resolveComWixpressMembershipV2PlansPlansServiceV2Url({
                protoPath: '/v2/plans',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createPlan.fromReq = fromReq;
    __createPlan.__isAmbassador = true;
    return __createPlan;
}
/**
 * Updates a pricing plan.
 * Updating a plan doesn't impact existing orders made for the plan. All orders keep the details of the original plan that was active at the time of purchase.
 */
export function updatePlan(payload) {
    var _a = serializer(_updatePlanRequest, {
        _plan: _plan,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updatePlanResponse, { _plan: _plan }).fromJSON;
    function __updatePlan(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v2.plan',
            method: 'PATCH',
            methodFqn: 'com.wixpress.membership.v2.plans.PlansServiceV2.UpdatePlan',
            url: resolveComWixpressMembershipV2PlansPlansServiceV2Url({
                protoPath: '/v2/plans/{plan.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updatePlan.fromReq = fromReq;
    __updatePlan.__isAmbassador = true;
    return __updatePlan;
}
/**
 * Sets visibility for pricing plans. Visible plans are considered public plans.
 * By default, pricing plans are public, meaning they are visible. Plans can be hidden so that site members and visitors can't choose them.
 * As opposed to archiving, setting visibility can be reversed. This means that a public plan can be hidden, and a hidden plan can be made public (visible). (An archived plan always remains archived and can't be made active again.)
 * Changing a plan’s visibility doesn't impact existing orders for the plan. All orders for hidden plans are still active and keep their perks.
 */
export function setPlanVisibility(payload) {
    var _a = serializer(_setPlanVisibilityRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_setPlanVisibilityResponse, {
        _plan: _plan,
    }).fromJSON;
    function __setPlanVisibility(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v2.plan',
            method: 'PUT',
            methodFqn: 'com.wixpress.membership.v2.plans.PlansServiceV2.SetPlanVisibility',
            url: resolveComWixpressMembershipV2PlansPlansServiceV2Url({
                protoPath: '/v2/plans/{id}/visibility',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __setPlanVisibility.fromReq = fromReq;
    __setPlanVisibility.__isAmbassador = true;
    return __setPlanVisibility;
}
/** Marks a pricing plan as the primary pricing plan. When viewing pricing plans on a site, the primary plan is highlighted with a customizable ribbon. Only a single plan can be marked as a primary plan at any given time. If there is an existing plan marked as primary, calling Make Plan Primary causes the existing primary plan to lose its primary status. */
export function makePlanPrimary(payload) {
    var _a = serializer(_makePlanPrimaryRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_makePlanPrimaryResponse, { _plan: _plan }).fromJSON;
    function __makePlanPrimary(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v2.plan',
            method: 'POST',
            methodFqn: 'com.wixpress.membership.v2.plans.PlansServiceV2.MakePlanPrimary',
            url: resolveComWixpressMembershipV2PlansPlansServiceV2Url({
                protoPath: '/v2/plans/{id}/make-primary',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __makePlanPrimary.fromReq = fromReq;
    __makePlanPrimary.__isAmbassador = true;
    return __makePlanPrimary;
}
/** Sets all pricing plans as not primary. When viewing pricing plans on a site, no plan is highlighted with a customizable ribbon. */
export function clearPrimary(payload) {
    var _a = serializer(_clearPrimaryRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_clearPrimaryResponse, {}).fromJSON;
    function __clearPrimary(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v2.plan',
            method: 'POST',
            methodFqn: 'com.wixpress.membership.v2.plans.PlansServiceV2.ClearPrimary',
            url: resolveComWixpressMembershipV2PlansPlansServiceV2Url({
                protoPath: '/v2/plans/clear-primary',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __clearPrimary.fromReq = fromReq;
    __clearPrimary.__isAmbassador = true;
    return __clearPrimary;
}
/**
 * Archives a single plan.
 * When a plan is archived, it's no longer visible as a public plan that can be chosen by site members or visitors.
 * This is because the plan's `public` property is automatically set to `false`.
 * Archived plans can't be purchased or reactivated.
 * Plan archiving doesn't impact existing orders made for the plan. All orders for the plan are still active and keep their perks, payment options, and terms.
 * Wix users can see archived plans in a site's dashboard under **Pricing Plans -> Archived Plans**.
 * > **Note:** An attempt to archive an already-archived plan throws an error.
 */
export function archivePlan(payload) {
    var _a = serializer(_archivePlanRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_archivePlanResponse, { _plan: _plan }).fromJSON;
    function __archivePlan(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v2.plan',
            method: 'POST',
            methodFqn: 'com.wixpress.membership.v2.plans.PlansServiceV2.ArchivePlan',
            url: resolveComWixpressMembershipV2PlansPlansServiceV2Url({
                protoPath: '/v2/plans/{id}/archive',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __archivePlan.fromReq = fromReq;
    __archivePlan.__isAmbassador = true;
    return __archivePlan;
}
/**
 * Archives multiple plans.
 * See "Archives a single plan" for more information.
 */
export function bulkArchivePlan(payload) {
    var _a = serializer(_bulkArchivePlanRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkArchivePlanResponse, {
        _bulkPlanResult: _bulkPlanResult,
        _plan: _plan,
    }).fromJSON;
    function __bulkArchivePlan(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v2.plan',
            method: 'POST',
            methodFqn: 'com.wixpress.membership.v2.plans.PlansServiceV2.BulkArchivePlan',
            url: resolveComWixpressMembershipV2PlansPlansServiceV2Url({
                protoPath: '/v2/bulk/plans/archive',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkArchivePlan.fromReq = fromReq;
    __bulkArchivePlan.__isAmbassador = true;
    return __bulkArchivePlan;
}
/**
 * Changes the display order of the plans on a site and in a site's dashboard.
 * To rearrange the order of the plans, provide a list of plan IDs in the desired order.
 * Include all public and hidden plans in the list you provide.
 * Make sure to provide **all** non-archived plan IDs to avoid unpredictable results.
 * Deprecated: display order of plans on site is controlled in widget settings.
 * @deprecated Will be removed on 2025-07-31.
 */
export function arrangePlans(payload) {
    var _a = serializer(_arrangePlansRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_arrangePlansResponse, {}).fromJSON;
    function __arrangePlans(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v2.plan',
            method: 'POST',
            methodFqn: 'com.wixpress.membership.v2.plans.PlansServiceV2.ArrangePlans',
            url: resolveComWixpressMembershipV2PlansPlansServiceV2Url({
                protoPath: '/v2/plans/arrange',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __arrangePlans.fromReq = fromReq;
    __arrangePlans.__isAmbassador = true;
    return __arrangePlans;
}
/** Returns a count of plans for a site. */
export function countPlans(payload) {
    var _a = serializer(_countPlansRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_countPlansResponse, {}).fromJSON;
    function __countPlans(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v2.plan',
            method: 'POST',
            methodFqn: 'com.wixpress.membership.v2.plans.PlansServiceV2.CountPlans',
            url: resolveComWixpressMembershipV2PlansPlansServiceV2Url({
                protoPath: '/v2/plans/count',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __countPlans.fromReq = fromReq;
    __countPlans.__isAmbassador = true;
    return __countPlans;
}
/** Checks whether a site has non-free plans and plans created before Pricing Plans became premium. */
export function getPlansPremiumStatus(payload) {
    var _a = serializer(_getPlansPremiumStatusRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getPlansPremiumStatusResponse, {}).fromJSON;
    function __getPlansPremiumStatus(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v2.plan',
            method: 'GET',
            methodFqn: 'com.wixpress.membership.v2.plans.PlansServiceV2.GetPlansPremiumStatus',
            url: resolveComWixpressMembershipV2PlansPlansServiceV2Url({
                protoPath: '/v2/plans/premium',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getPlansPremiumStatus.fromReq = fromReq;
    __getPlansPremiumStatus.__isAmbassador = true;
    return __getPlansPremiumStatus;
}
/** Retrieves a list of plans matching the filter and search phrase for the name. */
export function searchPlans(payload) {
    var _a = serializer(_searchPlansRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_searchPlansResponse, { _plan: _plan }).fromJSON;
    function __searchPlans(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v2.plan',
            method: 'POST',
            methodFqn: 'com.wixpress.membership.v2.plans.PlansServiceV2.SearchPlans',
            url: resolveComWixpressMembershipV2PlansPlansServiceV2Url({
                protoPath: '/v2/plans/search',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __searchPlans.fromReq = fromReq;
    __searchPlans.__isAmbassador = true;
    return __searchPlans;
}
//# sourceMappingURL=http.impl.js.map